import React from 'react';
import microsoftLogo from '../assets/microsoft-logo.png';
import qualcommLogo from '../assets/qualcomm-logo.png';
import rtxLogo from '../assets/rtx-logo.png';
import nvidiaLogo from '../assets/nvidia-logo.png';
import attLogo from '../assets/att-logo.png';
import '../styles.css';

const partners = [
  { name: 'Microsoft', logo: microsoftLogo },
  { name: 'RTX', logo: rtxLogo },
  { name: 'NVIDIA', logo: nvidiaLogo },
  { name: 'AT&T', logo: attLogo },
  { name: 'Qualcomm', logo: qualcommLogo },
];

const Partners: React.FC = () => {
  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="partners-header">
          <h2>Our Partners</h2>
        </div>

        <div className="partners-grid">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="partner-card"
              tabIndex={0}
              role="button"
              aria-label={`Learn more about ${partner.name}`}
            >
              <img src={partner.logo} alt={`${partner.name} logo`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;